import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { Footer } from '../../components/Footer';
import { Star, MapPin, Calendar, Shield, TrendingUp, Award, MessageCircle } from 'lucide-react';
import { StarRating } from '../../components/StarRating';
export function SellerProfilePage() {
  const {
    id
  } = useParams();
  const sellerProfile = {
    name: 'Rajesh Kumar',
    initials: 'RK',
    memberSince: '2022-03-15',
    location: 'Pune, Maharashtra',
    verificationStatus: 'verified',
    overallRating: 4.8,
    totalReviews: 24,
    totalSales: 8,
    responseTime: '2 hours',
    responseRate: '98%'
  };
  const listings = [{
    id: 1,
    title: 'Premium Corner Plot in Hinjewadi Phase 1',
    price: '₹45 Lakhs',
    size: '2400 sq ft',
    location: 'Hinjewadi, Pune',
    status: 'Active',
    views: 245
  }, {
    id: 2,
    title: 'Residential Plot near Metro Station',
    price: '₹38 Lakhs',
    size: '2000 sq ft',
    location: 'Baner, Pune',
    status: 'Active',
    views: 189
  }, {
    id: 3,
    title: 'Commercial Land on Main Road',
    price: '₹1.2 Cr',
    size: '5000 sq ft',
    location: 'Kharadi, Pune',
    status: 'Sold',
    views: 456
  }];
  const reviews = [{
    id: 1,
    buyerName: 'Amit Sharma',
    buyerInitials: 'AS',
    rating: 5,
    date: '2024-01-15',
    property: 'Plot in Wakad',
    comment: 'Excellent seller! Very transparent and cooperative throughout the process. All documents were genuine and verified.'
  }, {
    id: 2,
    buyerName: 'Priya Patel',
    buyerInitials: 'PP',
    rating: 5,
    date: '2024-01-10',
    property: 'Land in Hinjewadi',
    comment: 'Highly recommend! Clear communication and fair pricing. The property was exactly as described.'
  }, {
    id: 3,
    buyerName: 'Rohan Gupta',
    buyerInitials: 'RG',
    rating: 4,
    date: '2023-12-20',
    property: 'Plot in Baner',
    comment: 'Good experience overall. Minor delays in documentation but seller was helpful in resolving issues.'
  }];
  const ratingDistribution = {
    5: 18,
    4: 4,
    3: 1,
    2: 1,
    1: 0
  };
  return <div className="min-h-screen bg-[#f5f5f7] font-sans text-[#1f2933] flex flex-col" data-id="element-5425">
      {/* Header */}
      <header className="bg-white border-b border-gray-300 py-4 px-6 md:px-12" data-id="element-5426">
        <Link to="/" className="flex items-center gap-2" data-id="element-5427">
          <div className="w-8 h-8 bg-[#1f2933] rounded-sm" data-id="element-5428"></div>
          <span className="font-bold text-xl tracking-tight" data-id="element-5429">
            Citiplots.com
          </span>
        </Link>
      </header>

      <main className="flex-1 max-w-6xl mx-auto px-6 py-12" data-id="element-5430">
        {/* Breadcrumb */}
        <div className="mb-6" data-id="element-5431">
          <Link to="/" className="text-sm text-gray-600 hover:text-gray-900" data-id="element-5432">
            Home
          </Link>
          <span className="text-sm text-gray-400 mx-2" data-id="element-5433">/</span>
          <span className="text-sm text-gray-900" data-id="element-5434">Seller Profile</span>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-5435">
          {/* Left Column - Seller Info */}
          <div className="lg:col-span-1 space-y-6" data-id="element-5436">
            {/* Profile Card */}
            <div className="bg-white border border-gray-300 p-6" data-id="element-5437">
              <div className="flex flex-col items-center text-center mb-6" data-id="element-5438">
                <div className="w-24 h-24 bg-gray-200 rounded-full flex items-center justify-center text-3xl font-bold mb-4" data-id="element-5439">
                  {sellerProfile.initials}
                </div>
                <h1 className="text-2xl font-bold mb-2" data-id="element-5440">
                  {sellerProfile.name}
                </h1>
                {sellerProfile.verificationStatus === 'verified' && <div className="flex items-center gap-2 px-3 py-1 bg-green-50 border border-green-200 text-green-700 text-xs font-bold rounded" data-id="element-5441">
                    <Shield className="w-4 h-4" data-id="element-5442" />
                    VERIFIED SELLER
                  </div>}
              </div>

              <div className="space-y-3 text-sm" data-id="element-5443">
                <div className="flex items-center gap-2 text-gray-600" data-id="element-5444">
                  <MapPin className="w-4 h-4" data-id="element-5445" />
                  <span data-id="element-5446">{sellerProfile.location}</span>
                </div>
                <div className="flex items-center gap-2 text-gray-600" data-id="element-5447">
                  <Calendar className="w-4 h-4" data-id="element-5448" />
                  <span data-id="element-5449">
                    Member since{' '}
                    {new Date(sellerProfile.memberSince).toLocaleDateString('en-US', {
                    month: 'short',
                    year: 'numeric'
                  })}
                  </span>
                </div>
              </div>

              <button className="w-full mt-6 py-3 bg-[#1f2933] text-white font-bold hover:bg-gray-800" data-id="element-5450">
                Contact Seller
              </button>
            </div>

            {/* Stats Card */}
            <div className="bg-white border border-gray-300 p-6" data-id="element-5451">
              <h3 className="font-bold mb-4" data-id="element-5452">Seller Statistics</h3>
              <div className="space-y-4" data-id="element-5453">
                <div className="flex items-center justify-between pb-3 border-b border-gray-200" data-id="element-5454">
                  <span className="text-sm text-gray-600" data-id="element-5455">Overall Rating</span>
                  <div className="flex items-center gap-2" data-id="element-5456">
                    <StarRating rating={sellerProfile.overallRating} size="sm" data-id="element-5457" />
                  </div>
                </div>
                <div className="flex items-center justify-between pb-3 border-b border-gray-200" data-id="element-5458">
                  <span className="text-sm text-gray-600" data-id="element-5459">Total Reviews</span>
                  <span className="font-bold" data-id="element-5460">
                    {sellerProfile.totalReviews}
                  </span>
                </div>
                <div className="flex items-center justify-between pb-3 border-b border-gray-200" data-id="element-5461">
                  <span className="text-sm text-gray-600" data-id="element-5462">
                    Successful Sales
                  </span>
                  <span className="font-bold" data-id="element-5463">{sellerProfile.totalSales}</span>
                </div>
                <div className="flex items-center justify-between pb-3 border-b border-gray-200" data-id="element-5464">
                  <span className="text-sm text-gray-600" data-id="element-5465">Response Time</span>
                  <span className="font-bold text-green-600" data-id="element-5466">
                    {sellerProfile.responseTime}
                  </span>
                </div>
                <div className="flex items-center justify-between" data-id="element-5467">
                  <span className="text-sm text-gray-600" data-id="element-5468">Response Rate</span>
                  <span className="font-bold text-green-600" data-id="element-5469">
                    {sellerProfile.responseRate}
                  </span>
                </div>
              </div>
            </div>

            {/* Badges */}
            <div className="bg-white border border-gray-300 p-6" data-id="element-5470">
              <h3 className="font-bold mb-4" data-id="element-5471">Achievements</h3>
              <div className="grid grid-cols-2 gap-3" data-id="element-5472">
                <div className="p-3 border border-gray-200 text-center" data-id="element-5473">
                  <Award className="w-6 h-6 text-yellow-600 mx-auto mb-2" data-id="element-5474" />
                  <p className="text-xs font-bold" data-id="element-5475">Top Seller</p>
                </div>
                <div className="p-3 border border-gray-200 text-center" data-id="element-5476">
                  <TrendingUp className="w-6 h-6 text-blue-600 mx-auto mb-2" data-id="element-5477" />
                  <p className="text-xs font-bold" data-id="element-5478">Fast Response</p>
                </div>
                <div className="p-3 border border-gray-200 text-center" data-id="element-5479">
                  <Shield className="w-6 h-6 text-green-600 mx-auto mb-2" data-id="element-5480" />
                  <p className="text-xs font-bold" data-id="element-5481">Verified Docs</p>
                </div>
                <div className="p-3 border border-gray-200 text-center" data-id="element-5482">
                  <Star className="w-6 h-6 text-purple-600 mx-auto mb-2" data-id="element-5483" />
                  <p className="text-xs font-bold" data-id="element-5484">5-Star Rated</p>
                </div>
              </div>
            </div>
          </div>

          {/* Right Column - Listings & Reviews */}
          <div className="lg:col-span-2 space-y-6" data-id="element-5485">
            {/* Active Listings */}
            <div className="bg-white border border-gray-300 p-6" data-id="element-5486">
              <h2 className="font-bold text-xl mb-6" data-id="element-5487">
                Active Listings (
                {listings.filter(l => l.status === 'Active').length})
              </h2>
              <div className="space-y-4" data-id="element-5488">
                {listings.filter(l => l.status === 'Active').map(listing => <div key={listing.id} className="border border-gray-200 p-4 hover:bg-gray-50" data-id="element-5489">
                      <div className="flex items-start justify-between mb-2" data-id="element-5490">
                        <div className="flex-1" data-id="element-5491">
                          <Link to={`/listing/${listing.id}`} className="font-bold hover:text-blue-600" data-id="element-5492">
                            {listing.title}
                          </Link>
                          <p className="text-sm text-gray-600 flex items-center gap-1 mt-1" data-id="element-5493">
                            <MapPin className="w-3 h-3" data-id="element-5494" />
                            {listing.location}
                          </p>
                        </div>
                        <div className="text-right" data-id="element-5495">
                          <p className="font-bold text-lg" data-id="element-5496">{listing.price}</p>
                          <p className="text-xs text-gray-500" data-id="element-5497">
                            {listing.size}
                          </p>
                        </div>
                      </div>
                      <div className="flex items-center gap-4 text-xs text-gray-500 mt-3" data-id="element-5498">
                        <span data-id="element-5499">
                          Status:{' '}
                          <span className="text-green-600 font-bold" data-id="element-5500">
                            {listing.status}
                          </span>
                        </span>
                        <span data-id="element-5501">Views: {listing.views}</span>
                      </div>
                    </div>)}
              </div>
            </div>

            {/* Reviews Section */}
            <div className="bg-white border border-gray-300 p-6" data-id="element-5502">
              <h2 className="font-bold text-xl mb-6" data-id="element-5503">Reviews & Ratings</h2>

              {/* Rating Summary */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8 p-6 bg-gray-50 border border-gray-200" data-id="element-5504">
                <div className="flex flex-col items-center justify-center" data-id="element-5505">
                  <div className="text-5xl font-bold text-[#1f2933] mb-2" data-id="element-5506">
                    {sellerProfile.overallRating}
                  </div>
                  <StarRating rating={sellerProfile.overallRating} size="lg" showNumber={false} data-id="element-5507" />
                  <p className="text-sm text-gray-500 mt-2 font-mono" data-id="element-5508">
                    Based on {sellerProfile.totalReviews} reviews
                  </p>
                </div>

                <div className="space-y-2" data-id="element-5509">
                  {[5, 4, 3, 2, 1].map(rating => {
                  const count = ratingDistribution[rating as keyof typeof ratingDistribution];
                  const percentage = count / sellerProfile.totalReviews * 100;
                  return <div key={rating} className="flex items-center gap-3" data-id="element-5510">
                        <span className="text-sm font-medium w-8" data-id="element-5511">
                          {rating}★
                        </span>
                        <div className="flex-1 h-2 bg-gray-200 rounded-full overflow-hidden" data-id="element-5512">
                          <div className="h-full bg-yellow-500" style={{
                        width: `${percentage}%`
                      }} data-id="element-5513"></div>
                        </div>
                        <span className="text-xs text-gray-500 w-12 text-right font-mono" data-id="element-5514">
                          {count}
                        </span>
                      </div>;
                })}
                </div>
              </div>

              {/* Individual Reviews */}
              <div className="space-y-4" data-id="element-5515">
                {reviews.map(review => <div key={review.id} className="border border-gray-200 p-4" data-id="element-5516">
                    <div className="flex items-start gap-3 mb-3" data-id="element-5517">
                      <div className="w-10 h-10 bg-gray-200 rounded-full flex items-center justify-center font-bold text-sm" data-id="element-5518">
                        {review.buyerInitials}
                      </div>
                      <div className="flex-1" data-id="element-5519">
                        <div className="flex items-center justify-between mb-1" data-id="element-5520">
                          <div data-id="element-5521">
                            <p className="font-bold text-sm" data-id="element-5522">
                              {review.buyerName}
                            </p>
                            <p className="text-xs text-gray-500" data-id="element-5523">
                              Purchased: {review.property}
                            </p>
                          </div>
                          <span className="text-xs text-gray-500 font-mono" data-id="element-5524">
                            {review.date}
                          </span>
                        </div>
                        <StarRating rating={review.rating} size="sm" showNumber={false} data-id="element-5525" />
                      </div>
                    </div>
                    <p className="text-sm text-gray-700 leading-relaxed" data-id="element-5526">
                      {review.comment}
                    </p>
                  </div>)}
              </div>
            </div>

            {/* Past Sales */}
            <div className="bg-white border border-gray-300 p-6" data-id="element-5527">
              <h2 className="font-bold text-xl mb-6" data-id="element-5528">Past Sales</h2>
              <div className="space-y-4" data-id="element-5529">
                {listings.filter(l => l.status === 'Sold').map(listing => <div key={listing.id} className="border border-gray-200 p-4 bg-gray-50" data-id="element-5530">
                      <div className="flex items-start justify-between mb-2" data-id="element-5531">
                        <div className="flex-1" data-id="element-5532">
                          <p className="font-bold" data-id="element-5533">{listing.title}</p>
                          <p className="text-sm text-gray-600 flex items-center gap-1 mt-1" data-id="element-5534">
                            <MapPin className="w-3 h-3" data-id="element-5535" />
                            {listing.location}
                          </p>
                        </div>
                        <div className="text-right" data-id="element-5536">
                          <p className="font-bold text-lg" data-id="element-5537">{listing.price}</p>
                          <p className="text-xs text-gray-500" data-id="element-5538">
                            {listing.size}
                          </p>
                        </div>
                      </div>
                      <div className="flex items-center gap-4 text-xs text-gray-500 mt-3" data-id="element-5539">
                        <span className="px-2 py-1 bg-gray-200 text-gray-700 font-bold" data-id="element-5540">
                          SOLD
                        </span>
                        <span data-id="element-5541">Total Views: {listing.views}</span>
                      </div>
                    </div>)}
              </div>
            </div>
          </div>
        </div>
      </main>

      <Footer data-id="element-5542" />
    </div>;
}